/*
 * @category  Puma
 * @author    Deniss Dubinins <denissd@scandiweb.com | info@scandiweb.com>
 * @license   http://opensource.org/licenses/OSL-3.0 The Open Software License 3.0 (OSL-3.0)
 * @copyright Copyright (c) 2021 Scandiweb, Inc (https://scandiweb.com)
 */
import { cloneElement } from 'react';

export class CheckoutShippingBillingComponentPlugin {
    aroundRenderShippingStep = (args, callback, instance) => {
        const { onNationalIdNumberChange } = instance.props;

        return cloneElement(
            callback.apply(instance, args),
            { onNationalIdNumberChange }
        );
    };
}

const { aroundRenderShippingStep } = new CheckoutShippingBillingComponentPlugin();

export const config = {
    'Scandipwa/Component/CheckoutShippingBilling/Component': {
        'member-function': {
            renderShippingStep: aroundRenderShippingStep
        }
    }
};

export default config;
